// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tc","subtitle":"Uc","contentWrap":"Vc","imgWrap":"Wc","heading":"Xc","copy":"Yc"};